import { render } from "./ProjectRelevancy.vue?vue&type=template&id=5d82a8c8&scoped=true"
import script from "./ProjectRelevancy.vue?vue&type=script&lang=js"
export * from "./ProjectRelevancy.vue?vue&type=script&lang=js"

import "./ProjectRelevancy.vue?vue&type=style&index=0&id=5d82a8c8&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d82a8c8"]])

export default __exports__